module.exports = __webpack_public_path__ + "img/Group 7738.4894a166.png";